import { useState } from 'react';
import { Home, Bot, MessageCircle, Rss, Grid, DollarSign, Wrench, Gamepad2, User, X } from 'lucide-react';

export function BottomNav({ current, navigate }) {
  const [showMore, setShowMore] = useState(false);

  const mainTabs = [
    { id: 'home', label: 'Home', icon: Home },
    { id: 'chat', label: 'Chat', icon: Bot },
    { id: 'messenger', label: 'Msgs', icon: MessageCircle },
    { id: 'social', label: 'Feed', icon: Rss },
    { id: 'more', label: 'More', icon: Grid }
  ];

  const moreItems = [
    { id: 'finance', label: 'Finance', icon: DollarSign },
    { id: 'tools', label: 'Tools', icon: Wrench },
    { id: 'games', label: 'Games', icon: Gamepad2 },
    { id: 'profile', label: 'Profile', icon: User }
  ];

  const handleTabClick = (id) => {
    if (id === 'more') {
      setShowMore(true);
    } else {
      navigate(id);
    }
  };

  const handleMoreItem = (id) => {
    navigate(id);
    setShowMore(false);
  };

  return (
    <>
      {/* More Drawer */}
      {showMore && (
        <>
          <div 
            className="fixed inset-0 bg-black/70 backdrop-blur-sm z-40" 
            onClick={() => setShowMore(false)}
            data-testid="more-overlay"
          />
          <div 
            className="fixed bottom-0 left-0 right-0 bg-[#0d0d12] border-t border-[#00d4ff]/20 z-50 p-4 pb-8 max-w-md mx-auto"
            style={{ boxShadow: '0 -10px 40px rgba(0, 212, 255, 0.1)' }}
            data-testid="more-drawer"
          >
            <div className="flex justify-between items-center mb-4">
              <h3 className="font-mono text-[10px] text-[#00d4ff] uppercase tracking-[0.2em]">More</h3>
              <button 
                onClick={() => setShowMore(false)} 
                className="p-2 hover:bg-[#111118] transition-colors"
                data-testid="close-more-btn"
              >
                <X className="w-4 h-4 text-[#4a4a60]" />
              </button>
            </div>
            
            {/* Sage Owl Branding */}
            <div className="flex justify-center mb-4">
              <img 
                src="/owl-logo.png" 
                alt="Sage" 
                className="w-20 h-20"
                style={{ filter: 'drop-shadow(0 0 15px rgba(0, 212, 255, 0.5))' }}
              />
            </div>
            
            <div className="grid grid-cols-4 gap-2">
              {moreItems.map((item) => (
                <button
                  key={item.id}
                  onClick={() => handleMoreItem(item.id)}
                  className={`flex flex-col items-center gap-2 p-3 rounded-lg transition-all ${
                    current === item.id 
                      ? 'bg-[#00d4ff]/10 border border-[#00d4ff]' 
                      : 'bg-[#08080c] border border-[#00d4ff]/30 hover:border-[#00d4ff] hover:bg-[#00d4ff]/5'
                  }`}
                  data-testid={`more-item-${item.id}`}
                >
                  <item.icon className={`w-5 h-5 ${current === item.id ? 'text-[#00d4ff]' : 'text-[#00d4ff]/70'}`} />
                  <span className={`font-mono text-[8px] uppercase tracking-wider ${
                    current === item.id ? 'text-[#00d4ff]' : 'text-[#e8e8f0]'
                  }`}>
                    {item.label}
                  </span>
                </button>
              ))}
            </div>
          </div>
        </>
      )}

      {/* Bottom Nav Bar */}
      <nav 
        className="fixed bottom-0 left-0 right-0 bg-[#08080c]/95 backdrop-blur-xl border-t border-[#1a1a24] z-30"
        data-testid="bottom-nav"
      >
        <div className="max-w-md mx-auto h-14 flex items-center justify-around px-2">
          {mainTabs.map((tab) => {
            const isActive = current === tab.id || (tab.id === 'more' && ['finance', 'tools', 'games', 'profile'].includes(current));
            return (
              <button
                key={tab.id}
                onClick={() => handleTabClick(tab.id)}
                className={`flex flex-col items-center justify-center gap-1 flex-1 py-2 transition-all ${
                  isActive ? 'text-[#00d4ff]' : 'text-[#4a4a60] hover:text-[#7a7a9a]'
                }`}
                data-testid={`nav-${tab.id}`}
              >
                <tab.icon className={`w-4 h-4 ${isActive ? 'drop-shadow-[0_0_4px_rgba(0,212,255,0.5)]' : ''}`} />
                <span className={`font-mono text-[8px] uppercase tracking-wider ${
                  isActive ? 'text-[#00d4ff]' : ''
                }`}>
                  {tab.label}
                </span>
              </button>
            );
          })}
        </div>
      </nav>
    </>
  );
}
